/* Carro lateral de Allure (JP 2026-09-08, rediseño 2026-09-18).
   Se abre desde la derecha sobre la tienda: el cliente agrega una pieza y sigue navegando
   sin cambiar de página. Habla con la Ajax API de Shopify (/cart.js, /cart/add.js,
   /cart/change.js), así que el carro es el REAL de la tienda — el botón "Ir a pagar" entra
   al checkout de Shopify con lo mismo que se ve acá.

   La configuración (envío gratis, reserva, protección y textos) la emite el snippet
   al-carrito-config en window.ALLURE_CART_CFG, que va en el layout y por eso está en TODAS
   las páginas. Si aun así faltara, el carro funciona con los valores de abajo.

   Dos cosas que no son obvias y conviene saber antes de tocar esto:

   1. Las líneas se mueven por `key`, no por número de línea. El índice de la Ajax API se
      corre cuando una línea desaparece, y acá además se ESCONDE una línea (la protección),
      así que el índice visible y el real dejarían de coincidir. El `key` es estable.

   2. La protección extra es un producto de verdad del catálogo: el interruptor lo agrega y
      lo quita del carro. Por eso se descuenta del conteo de artículos y del avance hacia el
      envío gratis — no es mercadería y contarla haría que el envío se "regalara" solo. */
(function(){
  var CFG = window.ALLURE_CART_CFG || {};
  var ENVIO_GRATIS = Number(CFG.envio_gratis != null ? CFG.envio_gratis : 100000); // en pesos
  var ENVIO_ON = CFG.envio_gratis_on !== false;
  var TXT_DEVOL = CFG.sello_devolucion || 'Tienes <b>30 días</b> para hacer tu devolución';
  var TXT_CUOTAS = CFG.sello_cuotas || 'Hasta <b>6 cuotas sin interés</b>';
  var LOGO_MP = CFG.logo_mp || '';

  var RES_ON = CFG.reserva_on !== false;
  var RES_MIN = Math.max(1, Number(CFG.reserva_min || 15));
  var RES_TXT = CFG.reserva_txt || 'Productos reservados por';
  var RES_FIN = CFG.reserva_vencida || 'Tu carro sigue guardado, pero el stock ya no está reservado';

  var PROT_ID = String(CFG.prot_variante || '').replace(/\D/g, '');
  var PROT_TIT = CFG.prot_titulo || 'Protección extra';
  var PROT_SUB = CFG.prot_bajada || 'Tu pedido con asistencia prioritaria de principio a fin.';

  var estado = {items: [], total: 0, count: 0};
  var panel, velo, cargando = false, reloj = null;

  function esc(s){ return (s==null?'':String(s)).replace(/[&<>"]/g,function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  /* Shopify entrega los montos en la unidad menor (x100) incluso en CLP, que no usa
     decimales: por eso se divide y se muestra sin centavos. */
  function money(cents){
    var v = Math.round((Number(cents)||0)/100);
    try { return '$' + v.toLocaleString('es-CL'); }
    catch(e){ return '$' + String(v).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  }

  function icono(n){
    var S='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">';
    if(n==='cart')  return S+'<circle cx="9" cy="20" r="1.6"/><circle cx="17" cy="20" r="1.6"/><path d="M2 3h3l2.4 11.2a1.5 1.5 0 0 0 1.5 1.2h7.7a1.5 1.5 0 0 0 1.5-1.2L21 7H6"/></svg>';
    if(n==='volver')return S+'<path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg>';
    if(n==='truck') return S+'<path d="M1 5h13v11H1z"/><path d="M14 9h4l3 3v4h-7"/><circle cx="6" cy="18.5" r="1.6"/><circle cx="17" cy="18.5" r="1.6"/></svg>';
    if(n==='lock')  return S+'<rect x="4" y="10.5" width="16" height="10.5" rx="2"/><path d="M8 10.5V7a4 4 0 0 1 8 0v3.5"/></svg>';
    if(n==='check') return S+'<circle cx="12" cy="12" r="9"/><path d="M8.2 12.3l2.6 2.6 5-5.2"/></svg>';
    if(n==='tag')   return S+'<path d="M20.6 12.6l-8 8a2 2 0 0 1-2.9 0l-6.3-6.3a2 2 0 0 1-.6-1.4V4.5a1.5 1.5 0 0 1 1.5-1.5h8.4c.5 0 1 .2 1.4.6l6.5 6.5a2 2 0 0 1 0 2.5z"/><circle cx="7.8" cy="7.8" r="1.2"/></svg>';
    if(n==='shield')return S+'<path d="M12 3l7.5 3v5.4c0 4.4-3 8.3-7.5 9.6-4.5-1.3-7.5-5.2-7.5-9.6V6z"/><path d="M9 12.2l2.1 2.1 4-4.2"/></svg>';
    return '';
  }

  /* ---------- Reserva: el reloj arranca cuando el carro deja de estar vacío ----------
     Vive en sessionStorage a propósito: si el cliente cierra la pestaña y vuelve mañana,
     se le ofrece una reserva nueva en vez de una vencida. Al vaciar el carro se borra. */
  function resInicio(){
    try {
      var v = sessionStorage.getItem('al_cart_reserva');
      if(v) return Number(v);
      var t = Date.now();
      sessionStorage.setItem('al_cart_reserva', String(t));
      return t;
    } catch(e){ return Date.now(); }   // navegación privada: el reloj vive solo en memoria
  }
  function resBorrar(){ try{ sessionStorage.removeItem('al_cart_reserva'); }catch(e){} }

  function resRestante(){
    return Math.max(0, RES_MIN*60 - Math.floor((Date.now() - resInicio())/1000));
  }

  function reservaHTML(){
    if(!RES_ON || !estado.items.length) return '';
    return '<div class="al-cart-reserva">'+reservaDentro()+'</div>';
  }

  function reservaDentro(){
    var s = resRestante();
    var candado = '<span class="al-cart-emo" aria-hidden="true">🔒</span>';
    if(s <= 0) return candado+'<span>'+esc(RES_FIN)+'</span>';
    var mm = Math.floor(s/60), ss = s%60;
    return candado+'<span>'+esc(RES_TXT)+' <time>'+mm+':'+(ss<10?'0':'')+ss+'</time></span>'+
      '<span class="al-cart-emo" aria-hidden="true">⏰</span>';
  }

  /* El reloj repinta SOLO su franja. Un render completo cada segundo tiraría el scroll de la
     lista al tope y mataría el foco del botón que el cliente esté usando. */
  function tic(){
    if(!panel) return;
    var n = panel.querySelector('.al-cart-reserva');
    if(!n) return;
    var s = resRestante();
    n.innerHTML = reservaDentro();
    n.classList.toggle('al-cart-reserva--poco', s > 0 && s <= 60);
  }
  function relojOn(){ if(RES_ON && !reloj) reloj = setInterval(tic, 1000); }
  function relojOff(){ if(reloj){ clearInterval(reloj); reloj = null; } }

  /* ---------- Protección extra ---------- */
  function protLinea(){
    if(!PROT_ID) return null;
    for(var i=0;i<estado.items.length;i++){
      if(String(estado.items[i].variant_id) === PROT_ID) return estado.items[i];
    }
    return null;
  }
  function itemsReales(){
    var p = PROT_ID;
    return estado.items.filter(function(it){ return String(it.variant_id) !== p; });
  }

  function protHTML(){
    if(!PROT_ID || !itemsReales().length) return '';
    var linea = protLinea();
    var precio = linea ? money(linea.original_line_price - (linea.total_discount || 0))
      : (CFG.prot_precio ? money(CFG.prot_precio) : '');
    return '<button type="button" class="al-cart-prot'+(linea?' on':'')+'" '+
        'aria-pressed="'+(linea?'true':'false')+'" onclick="AlCart.proteccion()">'+
        icono('shield')+
        '<span class="al-cart-prot-txt">'+
          '<b>'+esc(PROT_TIT)+(precio?' <i>'+precio+'</i>':'')+'</b>'+
          '<span>'+esc(PROT_SUB)+'</span>'+
        '</span>'+
        '<span class="al-cart-sw"><i></i></span>'+
      '</button>';
  }

  function proteccion(){
    if(cargando || !PROT_ID) return;
    var linea = protLinea();
    if(linea) return cambiar(linea.key, 0);
    bloquear(true);
    fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id: Number(PROT_ID), quantity: 1}]})
    })
    .then(function(r){ return r.json(); })
    .then(function(){ return cargar(); })
    .catch(function(){})
    .then(function(){ bloquear(false); });
  }

  /* ---------- Envío gratis ---------- */
  function subtotalReal(){
    var p = protLinea();
    if(!p) return estado.total;
    return estado.total - (p.original_line_price - (p.total_discount || 0));
  }

  function envioHTML(){
    if(!ENVIO_ON || !itemsReales().length) return '';
    var totalPesos = Math.round(subtotalReal()/100);
    var falta = ENVIO_GRATIS - totalPesos;
    var pct = ENVIO_GRATIS > 0 ? Math.max(0, Math.min(100, (totalPesos/ENVIO_GRATIS)*100)) : 100;
    var ok = falta <= 0;
    var txt = ok
      ? '<span class="al-cart-emo" aria-hidden="true">🎉</span>'+
        '<span>¡Felicidades! <b>Tu envío es gratis</b></span>'
      : 'Te faltan <b>'+money(falta*100)+'</b> para el <b>envío gratis</b>';

    /* La meta va escrita bajo la barra. Sin el número, "te faltan $51.256" obliga al cliente
       a sumar para saber cuánto tiene que gastar en total; con él, la barra se lee sola. */
    var meta = ok ? '' :
      '<small class="al-cart-meta">Envío gratis desde <b>'+money(ENVIO_GRATIS*100)+'</b></small>';

    return '<div class="al-cart-envio'+(ok?' al-cart-envio--ok':'')+'">'+
        '<p>'+txt+'</p>'+
        '<div class="al-cart-barra"><i style="width:'+pct.toFixed(1)+'%"></i></div>'+
        meta+
      '</div>';
  }

  function sellosHTML(){
    var mp = LOGO_MP
      ? '<img src="'+esc(LOGO_MP)+'" alt="Mercado Pago" loading="lazy">'
      : icono('cart');
    return '<div class="al-cart-sellos">'+
        '<div class="al-cart-sello">'+icono('volver')+'<span>'+TXT_DEVOL+'</span></div>'+
        '<div class="al-cart-sello">'+mp+'<span>'+TXT_CUOTAS+'</span></div>'+
      '</div>';
  }

  /* ---------- Lista ---------- */
  function itemsHTML(){
    var lista = itemsReales();
    if(!lista.length){
      return '<div class="al-cart-items"><div class="al-cart-vacio">'+
          icono('cart')+
          '<b>Tu carro está vacío</b>'+
          '<p>Busca tu repuesto por marca y modelo o por número de parte.</p>'+
          '<button type="button" class="al-cart-seguir" onclick="AlCart.cerrar()">Seguir comprando</button>'+
        '</div></div>';
    }
    var filas = lista.map(function(it){
      var img = it.image
        ? '<img src="'+esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2'))+'" alt="" loading="lazy">'
        : '';
      var variante = (it.variant_title && it.variant_title !== 'Default Title')
        ? '<div class="al-cart-var">'+esc(it.variant_title)+'</div>' : '';
      var k = esc(it.key);

      /* El precio tachado y el % salen del descuento REAL de la línea (cupón o descuento
         automático). Mientras las variantes no tengan precio comparativo cargado, un carro
         sin cupón no muestra nada acá — y eso es lo correcto: no hay ahorro que anunciar.

         Se calcula con `total_discount` y NO con la resta orig-final, porque un cupón de
         código (asignación "across", que es el caso de BIENVENIDO7) deja final_line_price
         IGUAL al original y reporta el descuento solo en total_discount. Con la resta, el
         ahorro del cupón no se vería. Medido en la tienda el 2026-09-18. */
      /* El ahorro SUMA las dos rebajas —la de lista y la del cupon— porque para el cliente
         es una sola: lo que habria pagado menos lo que paga. Antes se mostraba una o la
         otra, y con cupon aplicado la rebaja de lista desaparecia de la vista. El cupon se
         sigue nombrando aparte, en su chip. (JP 2026-09-19)

         Va en PESOS con el porcentaje entre parentesis: "$8.126" se entiende sin calcular.

         El descuento del cupon se lee de `total_discount` y NO de la resta orig-final:
         un cupon de codigo (asignacion "across") deja `final_line_price` IGUAL al original
         y reporta la rebaja solo ahi. Medido con BIENVENIDO7 el 2026-09-18. */
      var dtoL = it.total_discount || 0;
      var finL = it.original_line_price - dtoL;
      var listaL = listaDeLinea(it);
      var ahorroL = listaL - finL;
      var antes = '', ahorro = '';
      if(ahorroL > 0 && listaL > 0){
        antes = '<s class="al-cart-antes">'+money(listaL)+'</s>';
        var pct = Math.round(ahorroL / listaL * 100);
        ahorro = '<span class="al-cart-ahorro">Ahorras '+money(ahorroL)+
                 (pct >= 1 ? ' <i>('+pct+'%)</i>' : '')+'</span>';
      }
      var chip = '';
      if(it.discounts && it.discounts.length){
        chip = '<span class="al-cart-dto">'+icono('tag')+
          '<span>'+esc(it.discounts[0].title)+' <b>(-'+money(dtoL)+')</b></span></span>';
      }

      return '<div class="al-cart-item">'+
          '<a class="al-cart-img" href="'+esc(it.url||'#')+'">'+img+'</a>'+
          '<div class="al-cart-info">'+
            '<div class="al-cart-cab">'+
              '<div>'+
                '<a class="al-cart-tit" href="'+esc(it.url||'#')+'">'+esc(it.product_title||it.title)+'</a>'+
                variante+
              '</div>'+
              '<div class="al-cart-pp">'+
                '<b class="al-cart-precio">'+money(finL)+'</b>'+
                antes+ahorro+
              '</div>'+
            '</div>'+
            chip+
            '<div class="al-cart-fila">'+
              '<div class="al-cart-qty">'+
                '<button type="button" aria-label="Quitar uno" onclick="AlCart.cambiar(\''+k+'\','+(it.quantity-1)+')">−</button>'+
                '<span>'+it.quantity+'</span>'+
                '<button type="button" aria-label="Agregar uno" onclick="AlCart.cambiar(\''+k+'\','+(it.quantity+1)+')">+</button>'+
              '</div>'+
              '<button type="button" class="al-cart-del" onclick="AlCart.cambiar(\''+k+'\',0)">Eliminar</button>'+
            '</div>'+
          '</div>'+
        '</div>';
    }).join('');
    return '<div class="al-cart-items">'+filas+'</div>';
  }

  /* Lo que costaria la linea sin ninguna rebaja: el precio de lista si la variante lo
     tiene, y si no el de venta. `LISTA` la llena listaDe() preguntando al producto. */
  function listaDeLinea(it){
    var u = LISTA[it.variant_id];
    return (u ? u * it.quantity : it.original_line_price);
  }

  /* ---------- Cupon ----------
     Klaviyo manda el codigo por correo, asi que el cliente llega con el texto en la mano y
     no por un enlace /discount/. Sin esta caja tendria que pegarlo en el checkout, donde ya
     no ve el carro: el 5% no se reflejaria nunca aca.

     Aplicarlo es pedir /discount/<codigo>, lo mismo que hace el enlace, redirigido a
     /cart.js para que la respuesta sea el carro ya actualizado y no la portada entera.
     Shopify NO avisa si el codigo no existe —responde igual—, asi que se compara el
     descuento antes y despues: si no se movio, el codigo no sirvio. */
  var cuponAbierto = false, cuponAviso = '';

  function nombreCupon(){
    var c = (estado.cupones && estado.cupones[0]) || null;
    return c ? c.title : '';
  }

  function cuponCajaHTML(){
    if(estado.descuento > 0) return '';        // ya hay uno aplicado: no se ofrece otro
    if(!cuponAbierto){
      return '<button type="button" class="al-cart-cupon-link" onclick="AlCart.cuponAbrir()">'+
        '\u00bfTienes un cup\u00f3n de descuento?</button>';
    }
    return '<div class="al-cart-cupon-caja">'+
        '<input type="text" id="al-cupon" placeholder="Escribe tu c\u00f3digo" autocomplete="off" '+
          'aria-label="C\u00f3digo de descuento" onkeydown="if(event.key===\'Enter\'){AlCart.cuponAplicar();return false}">'+
        '<button type="button" onclick="AlCart.cuponAplicar()">Aplicar</button>'+
      '</div>'+
      (cuponAviso ? '<p class="al-cart-cupon-aviso">'+esc(cuponAviso)+'</p>' : '');
  }

  function cuponAbrir(){
    cuponAbierto = true; cuponAviso = ''; render();
    var i = panel && panel.querySelector('#al-cupon');
    if(i) i.focus();
  }

  function cuponAplicar(){
    var i = panel && panel.querySelector('#al-cupon');
    var code = (i && i.value || '').trim();
    if(!code || cargando) return;
    var antes = estado.descuento;
    cuponAviso = '';
    bloquear(true);
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js',
          {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(d){
        guardar(d);
        if(estado.descuento > antes){ cuponAbierto = false; }
        else { cuponAviso = 'No pudimos aplicar ese c\u00f3digo. Rev\u00edsalo e int\u00e9ntalo de nuevo.'; }
        render();
        return listaDe(estado.items).then(render);
      })
      .catch(function(){ cuponAviso = 'No pudimos aplicar ese c\u00f3digo.'; render(); })
      .then(function(){ bloquear(false); });
  }

  /* ---------- Pie ---------- */
  function pieHTML(){
    var lista = itemsReales();
    if(!lista.length) return '';

    /* Tres lineas y en este orden: lo que costaria normal, lo que se ahorra, lo que paga. */
    var normal = 0;
    lista.forEach(function(it){ normal += listaDeLinea(it); });
    var prot = protLinea();
    if(prot) normal += prot.original_line_price - (prot.total_discount || 0);
    var ahorro = normal - estado.total;

    var dtos = '';
    if(ahorro > 0){
      var cup = nombreCupon();
      dtos = '<div class="al-cart-linea al-cart-normal"><span>Precio normal</span><b>'+money(normal)+'</b></div>'+
        '<div class="al-cart-linea al-cart-dtos">'+
          '<span>Ahorras <em>Ahorras</em></span><b>-'+money(ahorro)+'</b>'+
        '</div>'+
        (cup && estado.descuento > 0
          ? '<p class="al-cart-cupon">'+icono('tag')+' Cup\u00f3n <b>'+esc(cup)+'</b> aplicado: '+
            money(estado.descuento)+' menos</p>'
          : '');
    }
    return '<div class="al-cart-pie">'+
        dtos+
        cuponCajaHTML()+
        '<div class="al-cart-linea al-cart-total"><span>Subtotal</span><b>'+money(estado.total)+'</b></div>'+
        sellosHTML()+
        '<a class="al-cart-pagar" href="/checkout">'+
          '<span class="al-cart-emo" aria-hidden="true">🔒</span>'+
          'Ir a pagar <i>•</i> '+money(estado.total)+'</a>'+
        '<button type="button" class="al-cart-seguir" onclick="AlCart.cerrar()">Seguir comprando</button>'+
        '<p class="al-cart-nota">El despacho se calcula en el siguiente paso.</p>'+
      '</div>';
  }

  function cuenta(){
    var n = 0;
    itemsReales().forEach(function(it){ n += it.quantity; });
    return n;
  }

  function render(){
    if(!panel) return;
    var n = cuenta();
    panel.innerHTML =
      '<div class="al-cart-top">'+
        icono('cart')+
        '<b>'+(n ? n + (n===1 ? ' artículo' : ' artículos') : 'Tu carro')+'</b>'+
        '<button type="button" class="al-cart-x" aria-label="Cerrar" onclick="AlCart.cerrar()">✕</button>'+
      '</div>'+
      reservaHTML()+
      envioHTML()+
      itemsHTML()+
      protHTML()+
      pieHTML();
    tic();
    syncBadge();
  }

  /* El header del SPA se vuelve a pintar en cada navegación, así que el contador se
     re-aplica desde acá en vez de guardarse en el markup. */
  function syncBadge(){
    var n = cuenta();
    document.querySelectorAll('.al-cart-btn').forEach(function(b){
      var e = b.querySelector('.al-cart-badge');
      if(e) e.textContent = n;
      b.classList.toggle('tiene', n > 0);
    });
  }

  /* OFERTA (JP 2026-09-18). La linea de /cart.js NO trae `compare_at_price`, asi que se le
     pregunta al producto: una vez por handle, guardado en memoria. Si la variante no tiene
     precio de lista no se pinta nada. Nunca se calcula un precio de lista acá. */
  var LISTA = {}, PEDIDO = {};
  function listaDe(items){
    var faltan = [];
    (items || []).forEach(function(it){
      if(it.handle && !PEDIDO[it.handle]){ PEDIDO[it.handle] = 1; faltan.push(it.handle); }
    });
    if(!faltan.length) return Promise.resolve();
    return Promise.all(faltan.map(function(h){
      return fetch('/products/'+encodeURIComponent(h)+'.js', {headers:{'Accept':'application/json'}})
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(p){
          ((p && p.variants) || []).forEach(function(v){
            if(v.compare_at_price) LISTA[v.id] = v.compare_at_price;
          });
        })
        .catch(function(){});                       // sin producto, la linea queda como esta
    }));
  }

  function guardar(data){
    estado.items = data.items || [];
    estado.total = data.total_price || 0;
    estado.count = data.item_count || 0;
    estado.descuento = data.total_discount || 0;
    estado.cupones = data.cart_level_discount_applications || [];
    if(!estado.items.length) resBorrar();
    else resInicio();
  }

  function cargar(){
    return fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(d){
        guardar(d); render();                       // el carro se ve al instante
        return listaDe(estado.items).then(function(){ render(); return d; });
      })
      .catch(function(){ render(); });
  }

  function crear(){
    velo = document.createElement('div');
    velo.className = 'al-cart-veil';
    velo.addEventListener('click', cerrar);

    panel = document.createElement('aside');
    panel.className = 'al-cart';
    panel.id = 'al-cart';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', 'Tu carro');
    panel.setAttribute('aria-hidden', 'true');

    document.body.appendChild(velo);
    document.body.appendChild(panel);
    document.addEventListener('keydown', function(e){
      if((e.key === 'Escape' || e.keyCode === 27) && panel.classList.contains('on')) cerrar();
    });
  }

  function abrir(){
    if(!panel) return;
    panel.classList.add('on');
    velo.classList.add('on');
    panel.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('al-cart-open');
    relojOn();
    cargar();
  }

  function cerrar(){
    if(!panel) return;
    panel.classList.remove('on');
    velo.classList.remove('on');
    panel.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.body.classList.remove('al-cart-open');
    relojOff();
  }

  function bloquear(v){
    cargando = v;
    if(panel) panel.classList.toggle('al-cart--cargando', v);
  }

  /* `ref` es el key de la línea (lo normal). Se acepta un número por compatibilidad con
     llamadas viejas, que usaban el índice de la Ajax API. */
  function cambiar(ref, cantidad){
    if(cargando) return;
    bloquear(true);
    var cuerpo = (typeof ref === 'number')
      ? {line: ref, quantity: Math.max(0, cantidad)}
      : {id: String(ref), quantity: Math.max(0, cantidad)};
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json', 'Accept':'application/json'},
      body: JSON.stringify(cuerpo)
    })
    .then(function(r){ return r.json(); })
    .then(function(d){ guardar(d); render(); })
    .catch(function(){})
    .then(function(){ bloquear(false); });
  }

  /* Reemplaza el POST clásico del formulario de compra: agrega sin recargar y abre el carro.
     Si el fetch falla (sin conexión, por ejemplo), deja que el formulario se envíe como
     siempre para no dejar al cliente sin poder comprar. */
  function add(form){
    if(!form) return true;
    var datos = new FormData(form);
    var btn = form.querySelector('button[type=submit]');
    var txt = btn ? btn.innerHTML : '';
    if(btn){ btn.disabled = true; btn.innerHTML = 'Agregando…'; }
    fetch('/cart/add.js', {method:'POST', body: datos, headers:{'Accept':'application/json'}})
      .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); })
      .then(function(){ return cargar(); })
      .then(function(){ abrir(); })
      .catch(function(){ form.submit(); })
      .then(function(){ if(btn){ btn.disabled = false; btn.innerHTML = txt; } });
    return false;
  }

  function init(){
    crear();
    render();
    cargar();
    /* Cualquier enlace a /cart abre el carro lateral en vez de cambiar de página. */
    document.addEventListener('click', function(e){
      var a = e.target.closest && e.target.closest('a[href="/cart"], a[href$="/cart"]');
      if(a){ e.preventDefault(); abrir(); }
    });
  }

  window.AlCart = {abrir: abrir, cerrar: cerrar, cambiar: cambiar, add: add,
                   cargar: cargar, syncBadge: syncBadge, icono: icono,
                   proteccion: proteccion, cuponAbrir: cuponAbrir, cuponAplicar: cuponAplicar};

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
